import React from 'react'
import './CheckoutProduct.css'
// import product_4 from './img/product_4.jpg'
import StarIcon from '@mui/icons-material/Star';
import { useStateValue } from './StateProvider'


function CheckoutProduct({ id, image, title, price, rating }) {
    const [{ basket }, dispatch] = useStateValue();
    let dollarUSLocale = Intl.NumberFormat('en-US');


    const removeFromBasket =()=>{
        // remove the item from basket
        dispatch({
            type:'REMOVE_FROM_BASKET',
            id:id
        })
    }
    return (
        <div id={id} className="CheckoutProduct">
            <img className="CheckoutProduct__image" src={image} alt="" />
            <div className="CheckoutProduct__info">
                <p className="CheckoutProduct__title">{title}</p>
                <p className="CheckoutProduct__price"><small>Rs. </small><strong>{dollarUSLocale.format(price)}</strong></p>
                <div className="CheckoutProduct__rating">
                    {Array(rating).fill().map((_, i) => (
                        <p><StarIcon /></p>
                    ))}
                </div>
                <button onClick={removeFromBasket}>Remove from Basket</button>
            </div>
        </div>
    )
}

export default CheckoutProduct
